import {Component, Input, OnInit} from '@angular/core';
import {MatChipInputEvent, MatChipsModule} from '@angular/material/chips';
import {ENTER, COMMA} from '@angular/cdk/keycodes';
import {UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FilesService} from '../../services/files.service';
import {PdfToolsService} from '../../services/pdf-tools.service';
import {MatIconModule} from '@angular/material/icon';
import {NgFor, NgIf} from '@angular/common';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressBarModule} from '@angular/material/progress-bar';

@Component({
  selector: 'fmc-file-upload',
  templateUrl: './file-upload.component.html',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatChipsModule, NgFor, NgIf, MatIconModule, MatButtonModule, MatProgressBarModule]
})
export class FileUploadComponent implements OnInit {
  @Input() public idt: string;
  @Input() public idv: number;
  public formGroup: UntypedFormGroup;
  public loading = false;
  public visible = true;
  public selectable = true;
  public removable = true;
  public addOnBlur = true;
  public separatorKeysCodes = [ENTER, COMMA];
  public files: any = [];

  constructor(public filesService: FilesService,
              public pdfToolsService: PdfToolsService) {
    const fileUploadForm = new UntypedFormGroup({
      'file': new UntypedFormControl('')
    });
    this.formGroup = fileUploadForm;
  }

  ngOnInit() {
  }

  removeFile(file): void {
    const index = this.files.indexOf(file);

    if (index >= 0) {
      this.files.splice(index, 1);
    }
  }

  openFileBrowser(event) {
    event.preventDefault();
    const element: HTMLElement = document.getElementById('file') as HTMLElement;
    element.click();
  }

  onFileChange(event: any) {
    console.log(event);
    const files: FileList = event.target.files;
    for (let i = 0; i < files.length; i++) {
      this.updatePdfFile(files[i], i);
    }
  }

  updatePdfFile(file: File, index: number) {
    const reader: any = new FileReader();
    reader.onload = (e) => {
      const newFile = {
        'filename': `${this.idv} oth ${file.name}`,
        'documentTypeCode': 'oth',
        'data': reader.result.split(',')[1],
      };
      this.files.push(newFile);
    };
    reader.onerror = (error) => {
      console.log('Error: ', error);
    };
    const readerResult = reader.readAsDataURL(file);
  }

  submitFiles(data) {
    this.loading = true;
    this.files.forEach((file: any) => {
      let i = 0;
      this.filesService.uploadFile(file)
        .subscribe(response => {
            if (response) {
              this.pdfToolsService.sendFileSelectionData(response);

              this.filesService.updateDocType(response['_id'], {doc: file.documentTypeCode})
                .subscribe(responseDocType => {
                  i = i + 1;
                  if (i === this.files.length) {
                    this.loading = false;
                    this.files = [];
                    this.formGroup.reset();
                  }
                });
            } else {
              console.log('there was no response from the file save');
            }
          },
          error => {
            console.log(error);
          });
    });
  }
}
